module.exports = __webpack_public_path__ + "img/loading.a20bf9c7.png";